<div>
  <p>{{'mfa.pickerText' | translate}}</p>

  @if (mfaService.state.expired) {
  <div class="expire-error" data-testid="mfa-expired">
    <app-icon-warning />&nbsp;
    {{'mfa.expired'| translate: {url: "/"} }}
  </div>
  }

  <div class="picker">
    @if (providers && providers.email && providers.email.data && providers.email.data.length > 0) {
    @for (p of providers.email.data; track p.id) {
    <div class="option" data-testid="mfa-option-email" (click)="pickEmail(providers.email, p.id)">
      <span>{{'mfa.viaEmail' | translate : {email: p.obfuscated} }}</span>
      <app-icon-chevron-right />
    </div>
    }
    }
  </div>

  <div class="back">
    <a routerLink="/" queryParamsHandling="preserve">{{'mfa.cancel' | translate}}</a>
  </div>
</div>
